(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["haletern-buy-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('haletern-purchase')) {
  customElements.define('haletern-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.onSubmit) return;
      this.form = this.querySelector('form.ht-purchase');
      if (!this.form) return;
      this.onSubmit = async (event) => {
        event.preventDefault();
        const button = this.form.querySelector('[name="add"]');
        if (this.pending || !button || button.disabled) return;
        this.pending = true;
        const label = button.querySelector('span');
        const originalLabel = label.textContent;
        const error = this.form.querySelector('[data-purchase-error]');
        const status = this.form.querySelector('[data-purchase-status]');
        const formData = new FormData(this.form);
        formData.delete('return_to');
        formData.set('sections', 'cart-icon-bubble');
        formData.set('sections_url', window.location.pathname);
        error.hidden = true;
        error.textContent = '';
        status.replaceChildren();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.adding;
        let failureMessage = this.dataset.error;
        try {
          const add = async () => {
            let result;
            try {
              const addUrl = new URL(this.form.action, window.location.href);
              addUrl.pathname = addUrl.pathname.replace(/\.js$/, '') + '.js';
              const response = await fetch(addUrl.toString(), {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: formData
              });
              result = await response.json();
              if (!response.ok) {
                failureMessage = result.description || result.message || this.dataset.error;
                throw new Error(failureMessage);
              }
            } catch (failure) {
              await this.refreshBag().catch(() => {});
              throw failure;
            }
            await this.refreshBag(result).catch(() => {});
          };
          const queuedAdd = (this.constructor.cartQueue || Promise.resolve()).then(add, add);
          this.constructor.cartQueue = queuedAdd.catch(() => {});
          await queuedAdd;
          status.textContent = this.dataset.added;
        } catch (failure) {
          error.textContent = failureMessage;
          error.hidden = false;
        } finally {
          this.pending = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = originalLabel;
        }
      };
      this.form.addEventListener('submit', this.onSubmit);
    }
    async refreshBag(result) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      const markup = result?.sections?.['cart-icon-bubble'];
      if (typeof markup === 'string') {
        const section = new DOMParser().parseFromString(markup, 'text/html').getElementById('shopify-section-cart-icon-bubble');
        if (section) {
          bubble.replaceChildren(...section.childNodes);
          return;
        }
      }
      const response = await fetch(this.dataset.cartUrl.replace(/\.js$/, '') + '.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      const count = Number(cart.item_count);
      const label = bubble.querySelector('span');
      if (label && Number.isInteger(count) && count >= 0) {
        label.textContent = this.dataset.bagLabel + (count > 0 ? ' (' + count + ')' : '');
      }
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.onSubmit = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["haletern-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-haletern-newsletter]');
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const state = dialog.querySelector('[data-newsletter-result]');
    const form = dialog.querySelector('form');
    const title = dialog.querySelector('#HaleternNewsletterTitle');
    const preview = new URLSearchParams(window.location.search).get('newsletter_preview') === '1';
    const prefix = 'haletern:newsletter:v1:';
    const dismissedKey = `${prefix}dismissed`;
    const subscribedKey = `${prefix}subscribed`;
    let previousFocus = null;
    let automaticTimer = null;
    let pendingOpen = false;
    let currentPageDismissed = false;
    let pagePosition = null;
    let fitFrame = null;

    const fit = () => {
      if (!dialog.open) return;
      const viewport = window.visualViewport;
      const height = viewport ? viewport.height : window.innerHeight;
      const offset = viewport ? viewport.offsetTop : 0;
      const available = Math.max(0, height - 24);
      dialog.style.setProperty('--ht-letter-viewport-height', `${height}px`);
      dialog.removeAttribute('data-fit');
      const layout = dialog.querySelector('.ht-letter__layout');
      const contentHeight = () => layout.getBoundingClientRect().height + 2;
      if (contentHeight() > available) dialog.dataset.fit = 'compact';
      if (contentHeight() > available) dialog.dataset.fit = 'minimal';
      if (contentHeight() > available) dialog.dataset.fit = 'micro';
      dialog.style.top = `${offset + Math.max(12, (height - contentHeight()) / 2)}px`;
    };
    const scheduleFit = () => {
      window.cancelAnimationFrame(fitFrame);
      fitFrame = window.requestAnimationFrame(fit);
    };
    window.addEventListener('resize', scheduleFit);
    window.visualViewport?.addEventListener('resize', scheduleFit);
    window.visualViewport?.addEventListener('scroll', scheduleFit);
    document.fonts?.ready.then(scheduleFit);

    const read = (key) => {
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try {
          const value = window[storageName].getItem(key);
          if (value !== null) return value;
        } catch (error) {}
      }
      return null;
    };

    const write = (key, value) => {
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try {
          window[storageName].setItem(key, String(value));
          return;
        } catch (error) {}
      }
    };

    const alreadySubscribed = () => dialog.dataset.knownSubscriber === 'true' || read(subscribedKey) === '1';
    const recentlyDismissed = () => {
      const time = Number(read(dismissedKey));
      return Number.isFinite(time) && time > 0 && Date.now() - time < 30 * 24 * 60 * 60 * 1000;
    };
    const visible = (element) => !!element && element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden';
    const otherInteraction = () => {
      const modal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, .cart-drawer.is-open, .drawer.is-open')).some((element) => element !== dialog && !dialog.contains(element) && visible(element));
      const active = document.activeElement;
      const activeForm = active && active.closest('form');
      return modal || !!(activeForm && !dialog.contains(activeForm));
    };

    const open = (manual = false) => {
      if (dialog.open) return true;
      if (otherInteraction()) return false;
      if (!manual && !preview && (alreadySubscribed() || recentlyDismissed() || currentPageDismissed)) return true;
      previousFocus = document.activeElement;
      pagePosition = { x: window.scrollX, y: window.scrollY };
      document.documentElement.style.setProperty('--ht-letter-page-top', `${-pagePosition.y}px`);
      document.documentElement.classList.add('ht-letter-open');
      dialog.showModal();
      fit();
      window.requestAnimationFrame(() => title?.focus({ preventScroll: true }));
      return true;
    };

    const close = () => {
      if (!dialog.open) return;
      dialog.close();
    };

    dialog.querySelectorAll('[data-haletern-newsletter-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog.addEventListener('close', () => {
      currentPageDismissed = true;
      pendingOpen = false;
      if (!preview && state?.dataset.newsletterResult !== 'success') write(dismissedKey, Date.now());
      document.documentElement.classList.remove('ht-letter-open');
      document.documentElement.style.removeProperty('--ht-letter-page-top');
      if (pagePosition) window.scrollTo({ left: pagePosition.x, top: pagePosition.y, behavior: 'instant' });
      pagePosition = null;
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    });
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-haletern-newsletter-open]');
      if (!trigger) return;
      event.preventDefault();
      open(true);
    });
    document.addEventListener('haletern:newsletter:open', () => open(true));

    const schedule = (delay = 5000) => {
      window.clearTimeout(automaticTimer);
      automaticTimer = window.setTimeout(() => {
        if (document.hidden || otherInteraction()) {
          pendingOpen = true;
          return;
        }
        pendingOpen = false;
        open();
      }, delay);
    };

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && pendingOpen && !currentPageDismissed) schedule(1500);
    });
    document.addEventListener('focusout', () => {
      if (pendingOpen && !currentPageDismissed) schedule(2000);
    });
    document.addEventListener('close', () => {
      if (pendingOpen && !currentPageDismissed) schedule(1500);
    }, true);
    form?.addEventListener('submit', () => {
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
    });
    window.addEventListener('pageshow', () => {
      const button = form?.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });

    if (state?.dataset.newsletterResult === 'success') {
      if (!preview) write(subscribedKey, '1');
      window.requestAnimationFrame(() => open(true));
    } else if (state?.dataset.newsletterResult === 'error') {
      window.requestAnimationFrame(() => open(true));
    } else if (preview) {
      window.requestAnimationFrame(() => open(true));
    } else if (!alreadySubscribed() && !recentlyDismissed()) {
      schedule();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["haletern-range"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('haletern-range')){
  customElements.define('haletern-range',class extends HTMLElement{
    connectedCallback(){
      if(this.boundClick)return;
      this.openers=new Map();
      this.boundClick=(event)=>{
        const opener=event.target.closest('[data-range-open]');
        if(opener&&this.contains(opener)){
          const dialog=this.querySelector('#'+CSS.escape(opener.dataset.rangeOpen));
          if(dialog&&!dialog.open){
            event.preventDefault();
            this.openers.set(dialog,opener);
            if(dialog.hasAttribute('data-label-dialog')){
              const image=dialog.querySelector('[data-label-image]');
              if(!image.getAttribute('src'))image.src=image.dataset.labelSrc;
            }
            dialog.showModal();
            if(dialog.hasAttribute('data-label-dialog'))this.setLabelZoom(dialog,100);
          }
          return;
        }
        const zoom=event.target.closest('[data-label-zoom]');
        if(zoom){
          const dialog=zoom.closest('[data-label-dialog]');
          const current=Number(dialog.dataset.zoom||100);
          this.setLabelZoom(dialog,zoom.dataset.labelZoom==='fit'?100:current+(zoom.dataset.labelZoom==='in'?50:-50));
          return;
        }
        const closer=event.target.closest('[data-range-close]');
        if(closer){closer.closest('dialog').close();return;}
        if(event.target.tagName==='DIALOG'){
          const rect=event.target.getBoundingClientRect();
          if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();
        }
      };
      this.boundClose=(event)=>{this.openers.get(event.target)?.focus();this.openers.delete(event.target);};
      this.addEventListener('click',this.boundClick);
      this.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',this.boundClose));
      this.boundResize=()=>this.querySelectorAll('[data-label-dialog][open]').forEach(dialog=>this.setLabelZoom(dialog,Number(dialog.dataset.zoom||100)));
      window.addEventListener('resize',this.boundResize);
    }
    setLabelZoom(dialog,value){
      const zoom=Math.max(100,Math.min(600,value));
      const viewport=dialog.querySelector('.ht-range__label-viewport');
      const image=dialog.querySelector('[data-label-image]');
      const viewportStyle=getComputedStyle(viewport);
      const dialogStyle=getComputedStyle(dialog);
      const pixels=value=>Number.parseFloat(value)||0;
      const horizontalInset=pixels(viewportStyle.paddingLeft)+pixels(viewportStyle.paddingRight)+pixels(viewportStyle.borderLeftWidth)+pixels(viewportStyle.borderRightWidth);
      const verticalInset=pixels(viewportStyle.paddingTop)+pixels(viewportStyle.paddingBottom)+pixels(viewportStyle.borderTopWidth)+pixels(viewportStyle.borderBottomWidth);
      const dialogInset=dialogStyle.boxSizing==='border-box'?pixels(dialogStyle.paddingTop)+pixels(dialogStyle.paddingBottom)+pixels(dialogStyle.borderTopWidth)+pixels(dialogStyle.borderBottomWidth):0;
      const dialogBudget=(pixels(dialogStyle.maxHeight)||window.innerHeight)-dialogInset;
      const otherHeight=Array.from(dialog.children).filter(child=>child!==viewport).reduce((height,child)=>{
        const style=getComputedStyle(child);
        return height+child.getBoundingClientRect().height+pixels(style.marginTop)+pixels(style.marginBottom);
      },0);
      const viewportLimit=(pixels(viewportStyle.maxHeight)||dialogBudget)+(viewportStyle.boxSizing==='content-box'?verticalInset:0);
      const availableHeight=Math.max(1,Math.min(viewportLimit,dialogBudget-otherHeight)-verticalInset);
      const availableWidth=Math.max(1,viewport.getBoundingClientRect().width-horizontalInset);
      const imageWidth=Number(image.getAttribute('width'))||image.naturalWidth;
      const imageHeight=Number(image.getAttribute('height'))||image.naturalHeight;
      const aspect=imageWidth>0&&imageHeight>0?imageWidth/imageHeight:1;
      const fitWidth=Math.min(availableWidth,availableHeight*aspect);
      dialog.dataset.zoom=String(zoom);
      image.style.width=Math.max(1,Math.floor(fitWidth*zoom/100))+'px';
      dialog.querySelector('[data-label-level]').value=zoom+'%';
      dialog.querySelector('[data-label-zoom="out"]').disabled=zoom===100;
      dialog.querySelector('[data-label-zoom="in"]').disabled=zoom===600;
      if(zoom===100)viewport.scrollTo(0,0);
    }
    disconnectedCallback(){
      this.removeEventListener('click',this.boundClick);
      this.querySelectorAll('dialog').forEach(dialog=>dialog.removeEventListener('close',this.boundClose));
      window.removeEventListener('resize',this.boundResize);
      this.boundClick=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
